import { ALL_AUTHORS } from '../constants/manage/AuthorConstants';
import { ARCHIVED_FIELD, AUTHOR_FIELD, KNOWLEDGE_CATEGORY_FIELD, ORDER_FIELD, SEARCH_FIELD, VISIBILITY_LISTS_FIELD, VISIBILITY_TYPE_FIELD } from '../constants/manage/ArticleQueryConstants';
import TableConstants from '../constants/manage/TableConstants';
import { visibilityOptions } from '../constants/ArticleVisibilityConstants';
import StateConstants from '../constants/StateConstants';
import ArticlesQuery from '../records/manage/ArticlesQueryRecord';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
const setVisibility = (query, visibility) => {
  switch (visibility) {
    case visibilityOptions.ALL_AUDIENCE:
      {
        return query.delete(VISIBILITY_TYPE_FIELD).delete(VISIBILITY_LISTS_FIELD);
      }
    case visibilityOptions.PUBLIC:
      {
        return query.set(VISIBILITY_TYPE_FIELD, PublicAccessRuleTypes.PUBLIC);
      }
    case visibilityOptions.NOT_PUBLIC:
      {
        return query.set(VISIBILITY_TYPE_FIELD, [PublicAccessRuleTypes.LIST_MEMBERSHIP, PublicAccessRuleTypes.SSO_LOGIN]);
      }
    case visibilityOptions.RESTRICTED:
    case visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS:
      {
        return query.set(VISIBILITY_TYPE_FIELD, PublicAccessRuleTypes.LIST_MEMBERSHIP);
      }
    case visibilityOptions.ACCESS_GROUP_MEMBERSHIP:
    case visibilityOptions.SSO_WITH_ACCESS_GROUPS:
      {
        return query.set(VISIBILITY_TYPE_FIELD, PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP);
      }
    case visibilityOptions.SSO:
      {
        return query.delete(VISIBILITY_LISTS_FIELD).set(VISIBILITY_TYPE_FIELD, PublicAccessRuleTypes.SSO_LOGIN);
      }
    default:
      return query.merge({
        [VISIBILITY_LISTS_FIELD]: visibility,
        [VISIBILITY_TYPE_FIELD]: PublicAccessRuleTypes.LIST_MEMBERSHIP
      });
  }
};
const setState = (query, articleState) => {
  switch (articleState) {
    case StateConstants.ARCHIVED:
      return query.set(ARCHIVED_FIELD, 1);
    case StateConstants.DRAFT:
      return query.set(ARCHIVED_FIELD, 0).set('hs_published_at__is_null', '');
    case StateConstants.PUBLISHED:
      return query.set(ARCHIVED_FIELD, 0).set('hs_published_at__gt', 0);
    case StateConstants.DEFAULT:
    default:
      return query.set(ARCHIVED_FIELD, 0);
  }
};
const setOrder = (query, sortColumn, sortDir) => {
  if (sortColumn && (sortDir === TableConstants.DESC_ORDER || sortDir === TableConstants.ASC_ORDER)) {
    const order = `${sortDir === TableConstants.DESC_ORDER ? '-' : ''}${sortColumn}`;
    return query.set(ORDER_FIELD, order);
  }
  return query;
};
const getPropertyKeyForSortColumn = sortColumn => {
  switch (sortColumn) {
    case TableConstants.ARTICLE_NAME_PROPERTY:
      return 'hs_name';
    case TableConstants.CATEGORY_PROPERTY:
      return 'hs_knowledge_category_id';
    case TableConstants.UPDATED_AT_PROPERTY:
      return 'hs_updated_at';
    default:
      return '';
  }
};
export function getArticlesQuery(filterParams, articleState = StateConstants.DEFAULT, knowledgeBaseId) {
  const {
    authorId,
    categoryIds,
    searchTerm,
    sortColumn,
    sortDir,
    visibility,
    offset
  } = filterParams;
  let query = new ArticlesQuery(filterParams);
  if (authorId && authorId !== ALL_AUTHORS) {
    query = query.set(AUTHOR_FIELD, authorId);
  }
  if (categoryIds && categoryIds.count() > 0) {
    query = query.set(KNOWLEDGE_CATEGORY_FIELD, categoryIds.toJS());
  }
  if (searchTerm && searchTerm.trim().length > 0) {
    query = query.set(SEARCH_FIELD, searchTerm.trim());
  }
  query = setVisibility(query, visibility);
  query = setState(query, articleState);
  query = setOrder(query, getPropertyKeyForSortColumn(sortColumn), sortDir);
  query = query.set('hs_group_id', typeof knowledgeBaseId === 'string' ? parseInt(knowledgeBaseId, 10) : knowledgeBaseId);
  query = query.set('after', btoa(`${offset}`));
  return query;
}